import Vue from '~/main.js';
import axios from 'axios';
import { getDomainName, objectToQueryString } from '~/utils/urlUtils';

export default class WeChatFlow {
    /**
     * Redirects to open.weixin.qq.com and logs in a user to the site
     */
    static async startAuthFlow(redirectPath, redirectQuery) {
        const appId = process.env.VUE_APP_WECHAT_APP_ID;
        const state =
            getDomainName() +
            (redirectPath ? encodeURIComponent(redirectPath) : '/redirect') +
            (redirectQuery && !redirectPath
                ? objectToQueryString(redirectQuery)
                : '');
        const scope = 'snsapi_login';
        const redirectUri = this.redirectUri();

        window.open(
            `https://open.weixin.qq.com/connect/qrconnect?appid=${appId}&redirect_uri=${redirectUri}&response_type=code&scope=${scope}&state=${state}#wechat_redirect`,
            '_self'
        );
    }

    static async getAccessToken(authCode) {
        const state = getDomainName(); // Is necassary for storing which platform was used during registration
        return axios({
            method: 'GET',
            url: `${
                process.env.VUE_APP_IDENTITY_SERVER_URL
            }user/authenticate-wechat/?code=${authCode}&state=${state}`,
        });
    }

    static redirectUri() {
        return ''.concat(
            process.env.VUE_APP_IDENTITY_SERVER_URL,
            'user/authenticate-wechat/callback'
        );
    }
}
